// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2IvCk","content":"ManualTimeModal_content__Xilif"};